// extracted by mini-css-extract-plugin
export default {"formInput":"Text_formInput__S9MLR"};